export const RISK_TYPE = 'risk';
export const ISSUE_TYPE = 'issue';
export const DECISION_TYPE = 'decision';
export const OPPORTUNITY_TYPE = 'opportunity';

export const SOURCE_TYPE_MASTER = 'master';
export const SOURCE_TYPE_VENUE = 'venue';
export const SOURCE_TYPE_DEPARTMENT = 'department';

// Dispatched on `document` by the delegated trigger handler to open the RADIO
// island's risk modal in place, instead of navigating to the central register.
// `detail.generalRiskId` is absent when the trigger is an "add" affordance.
export const EDIT_GENERAL_RISK_EVENT = 'inbudget:radio:edit-general-risk';

export const MASTER_SOURCE_OPTION = { value: 'master', label: $t('Central') };

export const RAID_OPTIONS = [
    { value: RISK_TYPE, label: $t('Risk') },
    { value: ISSUE_TYPE, label: $t('Issue') },
    { value: DECISION_TYPE, label: $t('Decision') },
    { value: OPPORTUNITY_TYPE, label: $t('Opportunity') },
];

// IB-677 rework — inbudget brand palette, mirroring `tailwind.config.js`
// `theme.colors`. The flex-div dashboard bars/tiles use the `tw-bg-*` / `tw-text-*`
// token classes directly; this JS map holds the same values as raw hex for the
// only places a CSS class can't reach — the conic-gradient donut background and a
// handful of inline `style` colours. Keep these in lock-step with tailwind.config.
export const PALETTE = {
    charcoal: '#1B1C1D',
    charcoal75: '#545556',
    charcoal50: '#8D8E8E',
    charcoal25: '#C6C6C7',
    blue: '#055DF5',
    blue50: '#82AEFA',
    green: '#00DD8D',
    green25: '#BFF7E3',
    red: '#F00024',
    red75: '#F4405B',
    red50: '#F88092',
    red25: '#FBBFC8',
};

// RAG palette (inbudget brand tokens). Red = red.DEFAULT, amber = the red 50% tint
// (#F88092) per the ticket (not the legacy #ffbf00), green = green.DEFAULT.
export const RAG_RED = PALETTE.red;
export const RAG_AMBER = PALETTE.red50;
export const RAG_GREEN = PALETTE.green;
// Ordered R, A, G to match the count_by_classification key order used by the donuts.
export const RAG_COLORS = [RAG_RED, RAG_AMBER, RAG_GREEN];
// Tailwind background classes for RAG segments in the flex-div bars (R, A, G order).
export const RAG_CLASSES = ['tw-bg-red', 'tw-bg-red-50', 'tw-bg-green'];

export const CUSTOM_STYLES = {
    control: (provided, state) => ({
        ...provided,
        minHeight: '1.75rem',
        height: '1.75rem',
        width: 'max-content',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.5rem',
        paddingLeft: '1.25rem',
        paddingRight: '1.25rem',
        backgroundColor: 'rgb(59 130 246)',
        color: 'white',
        fontSize: '0.75rem',
        textDecoration: 'none',
        fontWeight: 600,
        borderRadius: '9999px',
        cursor: 'pointer',
        outline: 'none',
        '&:focus': {
            backgroundColor: 'rgb(191 219 254)',
        },
        '&:hover': {
            backgroundColor: 'rgb(191 219 254)',
        },
        border: 'none',
        boxShadow: 'none',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? 'rgb(45 45 45)' : 'white',
        color: state.isSelected ? 'white' : 'black',
        cursor: 'pointer',
        padding: '0.5rem',
        '&:hover': {
            backgroundColor: 'rgb(59 130 246)',
            color: 'white',
        },
    }),
    singleValue: (provided) => ({
        ...provided,
        color: 'white',
        margin: 0,
    }),
    input: (provided) => ({
        ...provided,
        margin: 0,
        padding: 0,
        lineHeight: '1.5rem',
    }),
    indicatorContainer: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
        alignItems: 'center',
        height: '100%',
        display: 'flex',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
    }),
    clearIndicator: (provided) => ({
        ...provided,
        padding: '0',
        margin: '0',
    }),
    placeholder: (provided) => ({
        ...provided,
        color: 'white',
    }),
};
